module.exports = __webpack_public_path__ + "9779d9a1/img/mini-logo.18817ee5.svg";